import { useQuery } from '@tanstack/react-query';
import type { CalendarEvent } from 'src/meetings/models';

export const useEvent = (eventId: string) => {
  const { data, isLoading, error, refetch, isRefetching } = useQuery<CalendarEvent>({
    queryKey: ['calendar-events', eventId],
  });

  return {
    event: data || null,
    refetch,
    isLoading,
    error,
    isRefetching,
  };
};
